import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"

const planSchema = z.object({
  name: z.string().min(1, "Name is required"),
  traffic_gb: z.number().min(1, "Traffic must be at least 1 GB"),
  duration_days: z.number().min(1, "Duration must be at least 1 day"),
  price_irr: z.number().min(0, "Price must be positive"),
  emoji: z.string().optional(),
  is_featured: z.boolean().optional(),
})

const planColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "name", type: "text", options: { label: "Name" } },
  { key: "traffic_gb", type: "number", options: { label: "Traffic (GB)" } },
  { key: "duration_days", type: "number", options: { label: "Duration (Days)" } },
  { key: "price_irr", type: "number", options: { label: "Price (IRR)" } },
  { key: "emoji", type: "text", options: { label: "Emoji" } },
  { key: "is_featured", type: "boolean", options: { label: "Featured" } },
  { key: "is_active", type: "status", options: { label: "Status" } },
]

const planFormFields = [
  { name: "name", label: "Name", type: "text", placeholder: "Enter plan name" },
  { name: "traffic_gb", label: "Traffic (GB)", type: "number", placeholder: "Enter traffic in GB" },
  { name: "duration_days", label: "Duration (Days)", type: "number", placeholder: "Enter duration in days" },
  { name: "price_irr", label: "Price (IRR)", type: "number", placeholder: "Enter price" },
  { name: "emoji", label: "Emoji", type: "text", placeholder: "Enter emoji" },
  { name: "is_featured", label: "Featured", type: "switch" },
]

function PricingPage() {
  return (
    <ResourcePage
      resource="pricing/plans"
      title="Pricing Plans"
      columns={planColumns}
      formFields={planFormFields}
      formSchema={planSchema}
    />
  )
}

export default PricingPage
